import { render, staticRenderFns } from "./ToMoney.vue?vue&type=template&id=24896d38&scoped=true&"
import script from "./ToMoney.vue?vue&type=script&lang=js&"
export * from "./ToMoney.vue?vue&type=script&lang=js&"
import style0 from "./ToMoney.vue?vue&type=style&index=0&id=24896d38&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24896d38",
  null
  
)

export default component.exports